import { formatShortDateTime } from "../../utils/utils";

export const transformToNotesRows = (notes: CustomerNotesResponse["rows"]) => {
  return (
    notes?.map((n) => ({
      id: n.id,
      note: n.note,
      createdBy: `${n.created_by_user.first_name || ""} ${
        n.created_by_user.last_name || ""
      }`,
      createdAt: formatShortDateTime(n.createdAt),
    })) || []
  );
};

export type NotesRow = ReturnType<typeof transformToNotesRows>[number];

export interface CustomerNotesResponse {
  rows: Note[];
  table_rows: NotesRow[];
  total_pages: number;
  current_page: number;
  page_size: number;
  total_items: number;
}

export interface Note {
  id: number;
  note: string;
  customer_id: number;
  status?: null;
  created_by: number;
  org_id: number;
  updated_by?: null;
  call_id_ref: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: null;
  created_by_user: CreatedByUser;
  updated_by_user?: null;
}
export interface CreatedByUser {
  user_name: string;
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  password?: null;
  access_level: string;
  state: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: null;
}
